<template>
    <div class="card mb-3">
        <div class="card-body">
            <h5>Billing address</h5>
            <div class="d-flex justify-content-center p-5" v-if="loading">
                <app-loading  />
            </div>
            <div v-else class="row">
                <div class="col-md-12">
                    <div class="position-relative form-group">
                        <label class="">Name</label>
                        <input placeholder="Full Name"
                               type="text"
                               class="form-control"
                               v-model="formData.name"
                        />
                        <span class="text-danger">
                            {{ $errorMessage(errors, 'name') }}
                        </span>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="position-relative form-group">
                        <label class="">Email</label>
                        <input placeholder="Email Address"
                               type="email"
                               class="form-control"
                               v-model="formData.email"
                        />
                        <span class="text-danger">
                            {{ $errorMessage(errors, 'email') }}
                        </span>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="position-relative form-group">
                        <label class="">Phone</label>
                        <input placeholder="01xxxxxxxxx"
                               type="text"
                               class="form-control"
                               v-model="formData.phone"
                        />
                        <span class="text-danger">
                            {{ $errorMessage(errors, 'phone') }}
                        </span>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="position-relative form-group">
                        <label>District</label>
                        <vue-search-select v-model="formData.district"
                                           placeholder="Select a district"
                                           :options="selectableDistrict"
                        />
                        <span class="text-danger">
                            {{ $errorMessage(errors, 'district_id') }}
                        </span>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="position-relative form-group">
                        <label class="">Thana</label>
                        <vue-search-select v-model="formData.thana"
                                           placeholder="Select a thana"
                                           :options="selectableThanas"
                        />
                        <span class="text-danger">
                            {{ $errorMessage(errors, 'thana_id') }}
                        </span>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="position-relative form-group">
                        <label class="">Address</label>
                        <textarea rows="4"
                                  class="form-control"
                                  placeholder="Full Address"
                                  v-model="formData.address"></textarea>
                        <span class="text-danger">
                            {{ $errorMessage(errors, 'address') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import {mapState} from "vuex";

    export default {
        name: "BillingAddress",
        components: {
            'vue-search-select': vSelect
        },
        props: {
            districts: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            thanas: {
                type: Array,
                default: function () {
                    return [];
                }
            },
        },
        data() {
            return {
                formData: {
                    district: {},
                    thana: {}
                },
                loading: false,
            }
        },
        methods: {
            getBillingAddress() {
                this.loading = true;
                window
                    .axios
                    .get('/api/user/billing-address')
                    .then(({data}) => {
                        this.formData = { ...data, district: {}, thana: {} };
                        if (Boolean(data.district_id)) {
                            this.formData.district = this.selectableDistrict
                                .find(d => Number(d.code) === Number(data.district_id));
                        }

                        if (Boolean(data.thana_id)) {
                            this.formData.thana = this.selectableThanas
                                .find(t => Number(t.code) === Number(data.thana_id));
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            }
        },
        computed: {
            ...mapState({
                errors: state => state.errors,
                response: state => state.response,
                success: state => state.success,
            }),
            selectableDistrict() {
               return this.districts.map(district => ({
                   label: district.name,
                   code: district.id
               }))
            },
            selectableThanas() {
                const thanas = Boolean(this.formData?.district?.code) ?
                    this.thanas.filter(thana => Number(thana.district_id) === Number(this.formData.district.code))
                    : this.thanas;
                return thanas.map(thana => ({
                    label: thana.name,
                    code: thana.id
                }));
            },
        },
        created() {
            this.$store.commit('SET_SHOW_CART_BAG', false);
            this.getBillingAddress();
        },
        watch: {
            formData: {
                handler: function (formData) {
                    this.$store.commit('SET_BILLING_ADDRESS', formData)
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style>
    .vs__search {
        height: 28px;
    }
</style>